import { Chip } from "@mui/material";
import {
  miniModeToLabel,
  TRAIN_COMPARE_MODELS,
  TRAIN_COMPARE_PARAMETERS,
} from "./miniModes";
import { serviceToLabel } from "./services";


const modelSelect = (value) => {
  let model = "";
  switch (value) {
    case "0":
      model = "PepBCL";
      break;
    case "1":
      model = "PepBCL";
      break;

    case "2":
      model = "PepBCL";
      break;

    default:
      break;
  }
  return model;
};
export const baseParameters = [
  {
    key: "model",
    label: "Running Model",
  },

  {
    key: "type",
    label: "Task Type",
  },
  {
    key: "createTime",
    label: "Created Time",
  },
  {
    key: "completeTime",
    label: "Completed Time",
  },
  {
    key: "requestTime",
    label: "Requesting Time",
  },
];


export const annotationParameters = baseParameters;
